module.exports = __webpack_public_path__ + "media/images/category/feature/coj_b/hero_mob-67ae09197d460d03a5cd2e0f9c62957c.jpg";